module.exports = __webpack_public_path__ + "static/media/sky-terrace-4.d295f6b4.jpg";